import { AnyAction } from 'redux'
import { Theme } from '../funnelOrder/theme'
import { UNLOCK_ORDER } from './index'

export enum ShortUrlStatus {
  Locked = 'LOCKED',
  Unlocked = 'UNLOCKED',
  Unassigned = 'UNASSIGNED',
  Unknown = 'UNKNOWN',
}

export interface Destination {
  city: string | null
  country: string | null
  driving_direction: string | null
}

export interface ShortUrlData {
  short_url: string
  status?: ShortUrlStatus
  force_allow_unlock: boolean
  unlock_time: string | null
  lock_time: string | null
  travellers: string[]
  travellers_formatted: string
  destinations: Destination[]
  destinations_total: number
  transportation: 'fly' | 'drive'
  personal_slug: string
  order_id: string
  display_pin_input: boolean | null
  reveal_drive_destination: boolean
  display_all: boolean
  more_to_unlock: boolean
}

export const defaultShortUrlData: ShortUrlData = {
  short_url: '',
  force_allow_unlock: false,
  unlock_time: null,
  lock_time: null,
  travellers: [],
  travellers_formatted: '',
  destinations: [],
  destinations_total: 0,
  transportation: 'drive',
  personal_slug: '',
  order_id: '',
  display_pin_input: null,
  reveal_drive_destination: false,
  display_all: false,
  more_to_unlock: false,
}

export const getTransportation = (state: ShortUrlData): Theme => {
  switch (state.transportation) {
    case 'drive':
      return Theme.drive
    default:
    case 'fly':
      return Theme.fly
  }
}
export const getTransportationName = (theme: Theme): 'drive' | 'fly' => {
  switch (theme) {
    case Theme.drive:
      return 'drive'
    default:
    case Theme.fly:
      return 'fly'
  }
}

export const getUnlockTime = (state: ShortUrlData): Date | null =>
  state.unlock_time !== null ? new Date(state.unlock_time) : null

export const SET_DATA = 'SET_DATA'
export const setShortUrlData = (data: ShortUrlData): AnyAction => ({
  type: SET_DATA,
  data,
})

export const DRIVE_REVEAL_DESTINATION = 'DRIVE_REVEAL_DESTINATION'
export const driveRevealDestination = (): AnyAction => ({
  type: DRIVE_REVEAL_DESTINATION,
})

const shortUrlReducer = (
  currentState: ShortUrlData = defaultShortUrlData,
  action: AnyAction,
): ShortUrlData => {
  switch (action.type) {
    case UNLOCK_ORDER:
      return Object.assign({}, currentState, {
        status: ShortUrlStatus.Unlocked,
        destinations: action.destinations,
      })
    case SET_DATA:
      return action.data
    case DRIVE_REVEAL_DESTINATION:
      return Object.assign({}, currentState, {
        status: ShortUrlStatus.Locked,
        force_allow_unlock: true,
        reveal_drive_destination: true,
      })
    default:
      return currentState
  }
}

export default shortUrlReducer
